const Heading = (props) =>{
    const classes = "font-lato font-semibold text-[30px] leading-[38px] text-[#101828] text-wrap lg:text-nowrap text-start " + props.className;
    return(
        <h2 className={classes}> {props.children}</h2>
    )
}
export default Heading